export default __webpack_public_path__ + "static/media/folder-open.5236b949.svg";